/**
 * Created by henian.xu on 2018/7/18.
 *
 */

import { Sv } from './Sv';

class Teacher extends Sv {
    constructor() {
        super();
        this.baseUrl += '/teacher';
    }

    data({ teacherName, sex, tel, idCardNo, certCatId, remarks, isAvailable, currentPage, pageSize } = {}) {
        return super.get('/data', {
            teacherName,
            sex,
            tel,
            idCardNo,
            certCatId,
            remarks,
            isAvailable,
            currentPage,
            pageSize,
        });
    }

    getDetail({ id }) {
        return super.get('/get', { id });
    }

    save({ id, sex, tel, idCardNo, remarks, teacherName, isAvailable, materialsListJson, certCatIdList } = {}) {
        const certCatIds = certCatIdList
            .reduce((prev, curr) => {
                prev.push(curr);
                return prev;
            }, [])
            .join(',');
        return super.post('/save', {
            id,
            teacherName,
            isAvailable,
            sex,
            tel,
            idCardNo,
            certCatIds,
            materialsListJson,
            remarks,
        });
    }

    delete({ ids } = {}) {
        return super.post('/delete', {
            ids,
        });
    }

    status({ id, isAvailable } = {}) {
        return super.post('/status', {
            id,
            isAvailable,
        });
    }

    selectByPage({ teacherName, certCatId, currentPage, pageSize } = {}) {
        return super.get('/selectByPage', {
            teacherName,
            certCatId,
            currentPage,
            pageSize,
        });
    }
}

export default new Teacher();
export { Teacher };
